import gsap from 'gsap';
import React, { createRef, useEffect } from 'react';
import styled from 'styled-components';
import { IconBase } from '../Base';
const Wrapper = styled.div ``;
const Group = styled.g `
  fill: var(--icon-background, ${({ theme }) => theme.background});
  stroke: var(--icon-color);
  stroke-linejoin: round;
  stroke-width: 1.5;
`;
export const IconLayers = (props) => {
    const wrapperRef = createRef();
    const triggerDone = () => {
        if (props.onDone) {
            props.onDone();
        }
    };
    useEffect(() => {
        if (props.running) {
            const wrapper = wrapperRef.current;
            const allLayer = wrapper?.querySelectorAll('path');
            if (!allLayer) {
                return;
            }
            gsap.to(allLayer, {
                keyframes: [
                    {
                        x: (index) => (index === 0 ? 2 : -2),
                        duration: 0.1,
                    },
                    {
                        x: (index) => (index === 0 ? -0.5 : 0.5),
                        duration: 0.15,
                    },
                    {
                        x: 0,
                        duration: 0.25,
                        onComplete: triggerDone,
                    },
                ],
            });
        }
    }, [props.running]);
    return (React.createElement(Wrapper, { className: props.className, ref: wrapperRef },
        React.createElement(IconBase, null,
            React.createElement(Group, null,
                React.createElement("path", { d: "M2.5 12.8533L9.98917 16.2075L17.5 12.8533L10.0108 9.5L2.5 12.8533Z" }),
                React.createElement("path", { d: "M2.5 8.85333L9.98917 12.2075L17.5 8.85333L10.0108 5.5L2.5 8.85333Z" })))));
};
//# sourceMappingURL=Layers.js.map